import { withNamespace } from "@/i18n/lazy-route"

/** The v1 API guide (LLD §9.7, Task 3.5), with the `apiGuide` namespace. */
export const ApiGuideScreen = withNamespace("apiGuide", () => import("./screens/ApiGuideScreen"), {
  en: () => import("@/i18n/locales/en/apiGuide.json"),
  fr: () => import("@/i18n/locales/fr/apiGuide.json"),
})
